export default __webpack_public_path__ + "asset/img/back-black~bf9b555e.png";